import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

// Usamos el logo desde la carpeta public/images
const logoPath = `${process.env.PUBLIC_URL}/images/logos/Logo_PROMEDIC-07.png`;

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // issue #439: fondo opaco al abrir el menú mobile

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <Navbar
        expand="lg"
        fixed="top"
        expanded={mobileMenuOpen}
        onToggle={(nextExpanded) => setMobileMenuOpen(nextExpanded)}
        className={`navbar-custom ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="brand-container" onClick={() => setMobileMenuOpen(false)}>
            <img
              src={logoPath}
              alt={t('nav.logoAlt', 'ProMedic Group Logo')}
              className="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {/* Public Navigation — always shown on public routes (Header is only used on public pages) */}
              <Nav.Link as={NavLink} to="/" end onClick={() => setMobileMenuOpen(false)}>
                {t('nav.home', 'Home')}
              </Nav.Link>
              <Nav.Link as={NavLink} to="/servicios" onClick={() => setMobileMenuOpen(false)}>
                {t('nav.services', 'Services')}
              </Nav.Link>
              <Nav.Link as={NavLink} to="/industrias" onClick={() => setMobileMenuOpen(false)}>
                {t('nav.industries', 'Industries')}
              </Nav.Link>
              <Nav.Link as={NavLink} to="/nosotros" onClick={() => setMobileMenuOpen(false)}>
                {t('nav.about', 'About Us')}
              </Nav.Link>
              <Nav.Link as={NavLink} to="/contacto" className="nav-contact-btn-custom" onClick={() => setMobileMenuOpen(false)}>
                {t('nav.contact', 'Contact')}
              </Nav.Link>
              <Nav.Item className="ms-lg-2 d-flex align-items-center language-switcher">
                <Button
                  variant={i18n.language === 'en' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => changeLanguage('en')}
                  className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                  aria-pressed={i18n.language === 'en'}
                >
                  EN
                </Button>
                <Button
                  variant={i18n.language === 'es' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => changeLanguage('es')}
                  className={`lang-btn ${i18n.language === 'es' ? 'active' : ''}`}
                  aria-pressed={i18n.language === 'es'}
                >
                  ES
                </Button>
              </Nav.Item>
              {isAuthenticated ? (
                <Nav.Item className="ms-lg-2">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => navigate('/dashboard')}
                    className="login-btn"
                  >
                    <i className="bi bi-speedometer2 me-1"></i>
                    {t('nav.goToSystem', 'Go to system')}
                  </Button>
                </Nav.Item>
              ) : (
                <Nav.Item className="ms-lg-2">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleLoginClick}
                    className="login-btn"
                  >
                    <i className="bi bi-person-circle me-1"></i>
                    {t('nav.login', 'Log in')}
                  </Button>
                </Nav.Item>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header; 